import { padl } from "./StringUtils";
import { Werkbonnen } from "../WebMethods";
import { setDefaultValue } from "./Utils";
import { i18n } from "../I18n";
import * as I18nKeysShared from "../Locales/shared-map.json";

// TODO: combine with i18next and jQuery-UI datepicker-nl somehow
export const dayNames: string[] = ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"];
export const dayNamesShort: string[] = ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"];
export const monthNamesLong: string[] = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
export const monthNamesShort: string[] = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];

function getDateTimeToObject(datetime: any): Date | null {
    if (typeof datetime === "string") {
        datetime = decodeURIComponent(datetime);
    }
    // probeer het soort datum/tijd-formaat te achterhalen
    datetime = tryParseAspNetDate(datetime); //is het een AspNet datumstring??? 
    if (datetime !== undefined && datetime !== null && typeof datetime === 'string' && (datetime.length === 18 || datetime.length === 19)) {
        let year = 0;
        let month = 0;
        let day = 0;
        let hh = 0;
        let mm = 0;
        let ss = 0;

        let str = datetime.substr(0, 10); // '30-12-1899' || '1899-12-30'
        let astr = str.split("-");

        if (astr[0].length === 4) {
            year = parseInt(astr[0], 10);
            day = parseInt(astr[2], 10);
        }
        else {
            day = parseInt(astr[0], 10);
            year = parseInt(astr[2], 10);
        }
        month = parseInt(astr[1], 10) - 1;

        str = datetime.substr(11);
        astr = str.split(":");
        hh = parseInt(astr[0], 10);
        mm = parseInt(astr[1], 10);
        ss = parseInt(astr[2], 10);

        let returnDate = new Date(year, month, day, hh, mm, ss);

        if (isValidDateObject(returnDate)) {
            return returnDate;
        }
    }
    else if (isValidDateObject(datetime)) {
        return datetime;
    }
    return null;
}

function getFormattedDateTime(dateTimeObj: any, format?: DateTimeFormats) {
    let result = "";
    let year = dateTimeObj.getFullYear();
    let month = dateTimeObj.getMonth() + 1; // maand is zerobased
    let day = dateTimeObj.getDate();
    let hh = dateTimeObj.getHours();
    let mm = dateTimeObj.getMinutes();
    let ss = dateTimeObj.getSeconds();

    switch (format) {
        case DateTimeFormats["dd-MM-yy"]:
            result = padl(day, "0", 2) + "-" + padl(month, "0", 2) + "-" + padl(year, "0", 4).substr(2, 2);
            break;
        case DateTimeFormats["d-M-yy"]:
            result = day + "-" + month + "-" + padl(year, "0", 4).substr(2, 2);
            break;
        case DateTimeFormats["d-M-yyyy"]:
            result = day + "-" + month + "-" + padl(year, "0", 4);
            break;
        case DateTimeFormats["yyyy-M-d"]:
            result = padl(year, "0", 4) + "-" + month + "-" + day;
            break;
        case DateTimeFormats["yy-M-d"]:
            result = padl(year, "0", 4).substr(2, 2) + "-" + month + "-" + day;
            break;
        case DateTimeFormats["yyyy-MM-dd"]:
            result = padl(year, "0", 4) + "-" + padl(month, "0", 2) + "-" + padl(day, "0", 2);
            break;
        case DateTimeFormats["HH:mm:ss"]:
            result = padl(hh, "0", 2) + ":" + padl(mm, "0", 2) + ":" + padl(ss, "0", 2);
            break;
        case DateTimeFormats["HH:mm"]:
            result = padl(hh, "0", 2) + ":" + padl(mm, "0", 2);
            break;
        case DateTimeFormats["H:m:s"]:
            result = hh + ":" + mm + ":" + ss;
            break;
        case DateTimeFormats["H:m"]:
            result = hh + ":" + mm;
            break;
        case DateTimeFormats["yyyy-MM-dd HH:mm:ss"]:
            result = padl(year, "0", 4) + "-" + padl(month, "0", 2) + "-" + padl(day, "0", 2) + " " +
                padl(hh, "0", 2) + ":" + padl(mm, "0", 2) + ":" + padl(ss, "0", 2);
            break;
        case DateTimeFormats["dd-MM-yyyy HH:mm"]:
            result = getFormattedDateTime(dateTimeObj) + ' ' + getFormattedDateTime(dateTimeObj, DateTimeFormats["HH:mm"]);
            break;
        case DateTimeFormats["dd-MM-yyyy"]:
        default: //dd-MM-yyyy
            result = padl(day, "0", 2) + "-" + padl(month, "0", 2) + "-" + padl(year, "0", 4);
            break;
    }
    return result;
}

// Retourneert een datum object voor de donderdag van de huidige week (donderdag valt altijd in het nieuwe jaar)
function getThursdayForWeeknumber(date: Date | string | null | undefined): Date {
    let newDate: Date;
    if (date instanceof Date) {
        newDate = new Date(date.getTime());
    } else if (date) {
        newDate = new Date(date);
    } else {
        newDate = new Date();
    }

    newDate.setHours(0, 0, 0, 0);
    // de donderdag van de huidige week bepaalt het jaar
    newDate.setDate(newDate.getDate() + 3 - (newDate.getDay() + 6) % 7);

    return newDate;
}

function tryParseAspNetDate(date: any): any {
    let out = parseAspNetDate(date);
    if (out === null) {
        out = date; //anders de orginele waarde hanteren
    }
    return out;
}

export function getMinDate(): Date {
    return new Date(1800, 0, 1); // return a new Date 01-01-1800;
}

// deze functie zet een datum/tijd (string, ASPNet, DateTime-object) om naar het gewenste formaat
// default formaat is dd-MM-yyyy
export function getDateTime(datetime: any, format?: DateTimeFormats): string {
    let DateTimeObj = getDateTimeToObject(datetime);
    if (DateTimeObj !== null) {
        return getFormattedDateTime(DateTimeObj, format);
    }
    return "";
}

// Deze functie parset een datum in yyyy-MM-dd of dd-MM-yyyy formaat naar een Date-object
export function parseDate(dateString: string | undefined | null): Date | null {
    let returnDate: Date | null = null;
    if (dateString !== undefined && dateString !== null && typeof dateString === 'string') {
        // Test op yyyy-MM-dd
        let match1 = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        let year, month, day;
        if (match1 !== null) {
            year = parseInt(match1[1], 10);
            month = parseInt(match1[2], 10) - 1; // Maanden beginnen met tellen vanaf 0
            day = parseInt(match1[3], 10);
            returnDate = new Date(year, month, day);
        } else {
            // Test op dd-MM-yyyy
            let match2 = dateString.match(/^(\d{2})-(\d{2})-(\d{4})$/);
            if (match2 !== null) {
                day = parseInt(match2[1], 10);
                month = parseInt(match2[2], 10) - 1;
                year = parseInt(match2[3], 10);
                returnDate = new Date(year, month, day);
            }
        }
    }
    return returnDate;
}

// Deze functie zet een datumstring om van dd-MM-yyyy naar yyyy-MM-dd.
export function reformatDateString(dateString: string): string | null {
    // Test op dd-MM-yyyy
    let match = dateString.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (match !== null) {
        return match[3] + '-' + match[2] + '-' + match[1];
    } else {
        return null;
    }
}

export function isValidDateTextDMYOrEmptyString(dateText: string, validateMinDate?: boolean, dateMinValue?: Date): boolean {
    if (dateText === "") {
        return true;
    }

    try {
        let result = $.datepicker.parseDate("dd-mm-yy", dateText);
        if (validateMinDate) {
            dateMinValue = setDefaultValue(dateMinValue, getMinDate());
            return result >= <Date>dateMinValue;
        }
        return true;
    }
    catch (e) {
        return false;
    }
}

//probeert van een string een datum te maken
//als het niet lukt krijg je een null terug
export function parseAspNetDate(date: string | undefined | null, dateParseOption: DateParseOption = DateParseOption.All): Date | null {
    let result: Date | null = null;
    if (date !== undefined && date !== null && typeof date === 'string') {
        let match = decodeURIComponent(date).match(/^(?:\/Date\((-?\d+)\)\/|\/SD\(((\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2}))\)\/)$/i);
        if (match !== null) {
            if (match[1] != undefined) {
                return new Date(+match[1]);
            }
            else if (match[2] != undefined) {
                let year = parseInt(match[3], 10);
                let month = parseInt(match[4], 10) - 1;
                let day = parseInt(match[5], 10);
                let hours = parseInt(match[6], 10);
                let minutes = parseInt(match[7], 10);
                let seconds = parseInt(match[8], 10);
                if (dateParseOption == DateParseOption.SecondsExcluded) {
                    seconds = 0;
                }
                return new Date(year, month, day, hours, minutes, seconds);
            }
        }
        else {
            return result;
        }
    }
    return result;
}

export function isValidDateObject(value: any): boolean {
    if (value && (value instanceof Date || Object.prototype.toString.call(value) === '[object Date]')) {
        return !isNaN(value.getTime());
    }
    return false;
}

export function getDiffHoursFromMilliSecondTimeSpan(milliseconds: number): number {
    return milliseconds / 3600000;
}

// Gets the hour difference from the time part of start datetime and end datetime
// ignoring the date part
export function getDiffHoursForTime(start: Date, end: Date): number {
    let diff = 0;
    if (start instanceof Date && end instanceof Date) {
        let newStart = new Date(0, 0, 0, start.getHours(), start.getMinutes(), start.getSeconds());
        let newEnd = new Date(0, 0, 0, end.getHours(), end.getMinutes(), end.getSeconds());
        diff = getDiffHoursFromMilliSecondTimeSpan(newEnd.getTime() - newStart.getTime());
    }
    return diff;
}

// Geeft een object terug waarin de opties voor de datepicker staan.
export function getDefaultDatepickerOptions(): DatePickerOptions {
    let result = {
        showOn: "button",
        onClose: function (_dateText: string, _widgetInstance: any): void {
            $(this).removeAttr("readonly"); // remove the readony attribute on input to fall back to default input behaviour
        },
        beforeShow: function (input: Element, widgetInstance: any): void {
            $(this).attr("readonly", "readonly"); // add readony attribute to input to suppress the keyboard on mobile devices (except iOS)
            let calendar = widgetInstance.dpDiv; // the div containing the calendar

            // fix the position of the calendar
            setTimeout(function () {
                calendar.position({
                    my: 'left center',
                    at: 'right+3 center',
                    collision: 'fit fit',
                    of: input
                });
            }, 1);
        },
        buttonText: "",
        minDate: getMinDate()
    };
    return result;
}

// Retourneert de datum van de maandag in de week van de opgegeven datum of, als geen datum is opgegeven, de huidige datum.
export function getMondayOfWeekFromDate(date?: Date | string | null | undefined): Date {
    let newDate: Date;
    if (date instanceof Date) {
        newDate = new Date(date.getTime());
    } else if (date) {
        newDate = new Date(date);
    } else {
        newDate = new Date();
    }
    newDate.setDate(newDate.getDate() - (newDate.getDay() || 7) + 1);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
}

// Retourneert de datum van de maandag in de gevraagde week
// Link: http://stackoverflow.com/a/4555559
export function getMondayOfWeek(year: number, week: number): Date {
    let j10 = new Date(year, 0, 10, 12, 0, 0),
        j4 = new Date(year, 0, 4, 12, 0, 0),
        mon1 = j4.getTime() - j10.getDay() * 86400000;

    let monday = new Date(mon1 + ((week - 1) * 7) * 86400000);
    monday.setHours(0, 0, 0, 0);
    return monday;
}

// Retourneert het jaartal van de week waarin de meegegeven datum valt (obv donderdag, die valt altijd in het nieuwe jaar)
export function getWeekYear(date: Date): number {
    // moet de datum van de eerste weekdag nog bepaald worden of wordt deze al meegegeven?
    let newDate = getThursdayForWeeknumber(date);

    return newDate.getFullYear();
}

// Retourneert het weeknummer voor de opgegeven datum of, als geen datum is opgegeven, de huidige datum.
export function getWeeknumber(date?: Date | string | null | undefined): number {
    // maak een datum object voor de donderdag dag van de huidige week
    let newDate = getThursdayForWeeknumber(date);

    // 4 januari is altijd week 1
    let week1 = new Date(newDate.getFullYear(), 0, 4);

    // stel in op donderdag in week 1 en tel het aantal weken vanaf de eerste week (_date tot week1).
    return 1 + Math.round(((newDate.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}

// Retourneert een datumbeschrijving met de volledige namen van dag en maand.
export function getDateLongNames(date: Date): string {
    let dayName = dayNames[date.getDay()].toLowerCase();
    let day = date.getDate();
    let monthName = monthNamesLong[date.getMonth()].toLowerCase();
    let year = date.getFullYear();
    return dayName + " " + day + " " + monthName + " " + year;
}

//uitrekenen aantal uur tussen twee tijdvelden rekening houdend met pauzetijd.
//er kan een leeg errorobject worden meegegeven die als een soort out-parameter dient
export function GetNumberOfHoursFromTwoTimeFields(tijd1: any, tijd2: any, pauzetijd?: any, errorobj?: { message: string }): number {
    let returnVal = 0;

    //aantal uur tussen twee tijdstippen ophalen
    if (tijd1 !== undefined && tijd1 !== null && tijd1 !== '' && tijd2 !== undefined && tijd2 !== null && tijd2 !== '') {
        Werkbonnen.GetNumberOfHoursFromTwoTimeFields(tijd1, tijd2, pauzetijd, { async: false })
            .done((resultset: any) => {
                returnVal = resultset.resultvalue.valueOf();
            })
            .fail((resultset: any) => {
                if (typeof errorobj === 'object') {
                    errorobj.message = resultset.message;
                }
            });
    }

    return returnVal;
}

export function validateAantalUur(element: JQuery, negativeAllowed: boolean, error: { text: string }): boolean {
    if (element.length > 0) {
        let pattern = element.attr("pattern");
        let value = element.val();
        let text = "";
        const title = element.attr("title");
        if (pattern !== undefined && pattern.length > 0) {
            let re = new RegExp(pattern);
            if (!re.test(value)) {
                text += title;
                if (typeof title === 'undefined' || text.length === 0) {
                    text = i18n.t(I18nKeysShared.dateTime.message.validation.invoerAantalUur);
                }
                if (!negativeAllowed && value < 0) {
                    text += i18n.t(I18nKeysShared.dateTime.message.validation.aantalGroterDanNul);
                } else if (negativeAllowed && value < -24) {
                    text += i18n.t(I18nKeysShared.dateTime.message.validation.aantalNietKleinerDanMin24);
                } else if (value > 24) {
                    text += i18n.t(I18nKeysShared.dateTime.message.validation.aantalNietGroterDan24);
                } else {
                    text += pattern.indexOf(":") > 0 ?
                        i18n.t(I18nKeysShared.dateTime.message.validation.aantalMoetAanUrenFormaatVoldoen) : i18n.t(I18nKeysShared.dateTime.message.validation.aantalMoetAanDecimaalFormaatVoldoen);
                }
                error.text = text;
                return false;
            }
        }
    }
    return true;
}

// Haalt gelocaliseerde volledig uitgeschreven datum string op met de opmaak zoals: maandag 5 augustus 2019
export function getLocalizedLongDateString(date: Date): string {
    var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('nl-NL', options);
}

// Vergelijkt de opgegeven datum met de andere opgegeven datum.
// Retourneert true als de opgegeven datum (dus zonder tijd) later is dan de andere datum.
export function isDatumLaterDanAndereDatum(datum: Date, andereDatum: Date): boolean {
    let datumMiddernacht = getDatumMiddernacht(datum);
    let andereDatumMiddernacht = getDatumMiddernacht(andereDatum);
    return datumMiddernacht > andereDatumMiddernacht;
}

function getDatumMiddernacht(datum: Date) {
    let datumMiddernacht = new Date(datum.getTime());
    datumMiddernacht.setHours(0, 0, 0, 0);
    return datumMiddernacht;
}

export enum DateTimeFormats {
    'dd-MM-yy',
    'd-M-yy',
    'd-M-yyyy',
    'yyyy-M-d',
    'yy-M-d',
    'yyyy-MM-dd',
    'HH:mm:ss',
    'HH:mm',
    'H:m:s',
    'H:m',
    'yyyy-MM-dd HH:mm:ss',
    'dd-MM-yyyy HH:mm',
    'dd-MM-yyyy'
}

export enum DateParseOption {
    All,
    SecondsExcluded
}

export interface DatePickerOptions {
    showOn: string;
    onClose: (dateText: string, widgetInstance: any) => void;
    beforeShow: (input: Element, widgetInstance: any) => void;
    minDate: Date;
}
